import request from "@/utils/request.js";


//用户
export const userLogin = (data) => {
  return request({
    url: "/login",
    method: "POST",
    data: data,
  });
};

//配置所选模型
export const UseModel = async function (data) {
  return request({
    url: "/user/use/model",
    method: "POST",
    data: data,
  });
};

export const userRegist = (data) => {
  return request({
    url: "/register",
    method: "POST",
    data: data,
  });
};

export const userDetail = () => {
  return request({
    url: "/user/info",
    method: "GET",
  });
};

export const updatePassword = (data) => {
  return request({
    url: "/set/password",
    method: "POST",
    data,
  });
};

export const userCurrent = () => {
  return new Promise((resolve, reject) => {
    try {
      const userData = localStorage.getItem("USER");
      if (!userData) {
        throw new Error("用户数据未找到");
      }
      const parsedData = JSON.parse(userData);
      resolve(parsedData);
    } catch (error) {
      reject(error);
    }
  });
};

// 模型
export const modelEdit = (data) => {
  return request({
    url: "/user/use/model",
    method: "POST",
    data: data,
  });
};

export const modelList = () => {
  // eslint-disable-next-line no-unused-vars
  return new Promise((resolve, reject) => {
    const data = [
      // {
      // 	text: 'AI-4o',
      // 	value: 'gpt-4o'
      // },
      {
        text: "KM",
        value: "moonshot-v1-auto",
      },
      {
        text: "DB",
        value: "ep-20241219161215-p2qsp",
      },
      {
        text: "DSC",
        value: "deepseek-chat",
      },
    ];
    resolve(data);
  });
};

export const modelCurrentList = async () => {
  try {
    const modelListData = await modelList();

    const userDetailResponse = await userDetail();

    if (userDetailResponse.data.code === 200) {
      const info = userDetailResponse.data.info;
      const modelIds = info.model_ids;

      const selectedModels = modelIds
        .map((id) => modelListData.find((model) => model.value === id))
        .filter((model) => model);

      return selectedModels;
    } else {
      console.warn("获取用户详情失败：", userDetailResponse.data.error);
      return [];
    }
  } catch (error) {
    console.warn("获取选中模型失败：", error);
    return [];
  }
};

export const modelCurrentText = async () => {
  try {
    const modelListData = await modelList();

    const userDetailResponse = await userDetail();

    if (userDetailResponse.data.code === 200) {
      const info = userDetailResponse.data.info;
      const modelIds = info.model_ids;

      const selectedModels = modelIds
        .map((id) => modelListData.find((model) => model.value === id)) // 找到匹配的模型
        .filter((model) => model) // 过滤掉未找到的模型（即 `undefined`）
        .map((model) => model.text); // 提取每个模型的 `text` 属性

      return selectedModels;
    } else {
      console.warn("获取用户详情失败：", userDetailResponse.data.error);
      return [];
    }
  } catch (error) {
    console.warn("获取选中模型失败：", error);
    return [];
  }
};

export const modelCurrentValue = async () => {
  try {
    const modelListData = await modelList();

    const userDetailResponse = await userDetail();

    if (userDetailResponse.data.code === 200) {
      const info = userDetailResponse.data.info;
      const modelIds = info.model_ids;

      const selectedModels = modelIds
        .map((id) => modelListData.find((model) => model.value === id)) // 找到匹配的模型
        .filter((model) => model) // 过滤掉未找到的模型（即 `undefined`）
        .map((model) => model.value); // 提取每个模型的 `value` 属性

      return selectedModels;
    } else {
      console.warn("获取用户详情失败：", userDetailResponse.data.error);
      return [];
    }
  } catch (error) {
    console.warn("获取选中模型失败：", error);
    return [];
  }
};

// 百度ocr
export const ocrBaidu = (data) => {
  return request({
    url: "/baidu/ocr/accurate",
    method: "POST",
    data: data,
  });
};

//会话
export const conversationAppend = (data) => {
  return request({
    url: "/save/parameter",
    method: "POST",
    data: data,
  });
};

export const conversationList = () => {
  return request({
    url: "/conversation/",
    method: "GET",
  });
};

export const conversationDetail = (data) => {
  return request({
    url: `/conversation/${data}`,
    method: "GET",
  });
};
/**
 * 收藏整个会话
 * @param title{string} 会话标题
 * @param conversation_id{number} 会话名称
 * @returns {Promise<AxiosResponse<any>>}
 */
export const collection_conversation = async function (title, conversation_id) {
  const obj = {};
  obj.title = title;
  obj.conversation_id = conversation_id;

  //   const form = new FormData();
  //   form.append("title", title);
  //   form.append("conversation_id", conversation_id);
  //   console.log(form, "form");

  return request({
    url: "/collection",
    method: "POST",
    headers: { "Content-Type": "multipart/form-data;charset=utf-8" },
    data: obj,
  });
  // return post('/collection', {headers: {'Content-Type': "multipart/form-data;charset=utf-8"}, data: form})
};

export const conversationDelete = (data) => {
  return request({
    url: `/conversation/${data}`,
    method: "DELETE",
  });
};

export const setUserCorrect = (data) => {
  return request({
    url: `/set/user/correct`,
    method: "POST",
    data: data,
  });
};
export const getIIntelligentWWizard = () => {
  return request({
    url: `/admin/intelligent/wizard`,
    method: "GET",
  });
};

// 删除所有会话
export const conversationDeleteAll = () => {
  return request({
    url: "/conversation/",
    method: "DELETE",
  });
};

// 案例
export const collectionList = () => {
  return request({
    url: "/collection",
    method: "GET",
  });
};

export const collectionPut = (data) => {
  return request({
    url: "/collection",
    method: "PUT",
    data: data,
  });
};

//获取模型提示词
export const modelCueword = () => {
  return request({
    url: "/admin/model/cueword",
    method: "GET",
  });
};

// export const collectAppend = (data) => {
//   return request({
//     url: "/collection",
//     method: "POST",
//     data: data,
//     headers: { "Content-Type": "multipart/form-data;charset=utf-8" },
//   });
// };

// export const collectAppendCase = (data) => {
//   return request({
//     url: "/collection",
//     method: "POST",
//     data: data,
//     headers: { "Content-Type": "multipart/form-data;charset=utf-8" },
//   });
// };
/**
 * 删除指定id的会话
 * @param chat_id{number} 会话id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const delete_chat_id = async function (chat_id) {

  const encoded_conversation_id = btoa(chat_id.toString());

  return request({
    url: `/conversation/${encoded_conversation_id}`,
    method: "DELETE",
  });
  // return del(`/conversation/${chat_id}`);
};

/**
 * 删除指定id的收藏
 * @param collect_id{number} 收藏id
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const delete_collect_id = async function (collect_id) {
  return request({
    url: `/collection?collect_id=${collect_id}`,
    method: "DELETE",
  });
  // return del(`/collection?collect_id=${collect_id}`)
};
/**
 * 删除指定常用词
 * @param id{number} 常用词id
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const delete_cue_word = async function (id) {
  return request({
    url: `/cueword?id=${id}`,
    method: "DELETE",
  });
  // return del(`/cueword?id=${id}`)
};

/**
 * 获取指定的会话上下文
 * @param conversation_id{number} 会话id
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const get_conversation_data = async function (conversation_id) {

  const encoded_conversation_id = window.btoa(conversation_id.toString());

  console.log('check-btoa:', btoa('2026'))

  // console.log(encoded_conversation_id);

  return request({
    url: `/conversation/${encoded_conversation_id}`,
    method: "GET",
  });
  // return get(`/conversation/${conversation_id}`)
};

export const collectDelete = (data) => {
  return request({
    url: "/collection?collect_id=" + data,
    method: "DELETE",
  });
};

// 提示词
export const wordsList = () => {
  return request({
    url: "/cueword",
    method: "GET",
  });
};

export const wordsAppend = (data) => {
  return request({
    url: "/cueword",
    method: "POST",
    data: data,
  });
};

export const wordsDelete = (data) => {
  return request({
    url: "/cueword?id=" + data,
    method: "DELETE",
  });
};

export const wordsEdit = (data) => {
  return request({
    url: "/cueword",
    method: "PUT",
    data: data,
  });
};

export const captureList = () => {
  // eslint-disable-next-line no-unused-vars
  return new Promise((resolve, reject) => {
    const data = [
      {
        title: "补充患者病历相关信息",
        keyword: [
          "病历",
          "病史",
          "既往史",
          "家族史",
          "出生史",
          "入院记录",
          "出院记录",
          "体征",
          "健康记录",
          "病程",
        ],
        type: "病历",
        index: [],
      },
      {
        title: "补充影像学检查相关信息",
        keyword: [
          "CT",
          "MRI",
          "DR",
          "X光",
          "彩超",
          "超声",
          "磁共振",
          "影像",
          "医技",
          "介入",
          "放射",
          "摄影",
          "X线",
          "造影",
          "DSA",
          "扫描",
          "平扫",
        ],
        type: "影像学检查报告",
        index: [],
      },
      {
        title: "补充实验室检验",
        keyword: [
          "甲状腺",
          "性激素",
          "肝功能",
          "生化",
          "检验",
          "尿液",
          "免疫",
          "微生物",
          "细胞",
          "内分泌",
          "实验室",
        ],
        type: "实验室检验报告",
        index: [],
      },
      {
        title: "补充其他资料（生活习惯、药物使用等）",
        keyword: ["生活", "睡眠", "药物", "遗传", "饮食", "习惯", "活动"],
        type: "其他",
        index: [],
      },
    ];
    resolve(data);
  });
};

export const captureSlice = (text) => {
  return new Promise((resolve, reject) => {
    try {
      const keyword = "进一步确定";
      const index = text.indexOf(keyword);

      if (index !== -1) {
        const result = text.slice(index + keyword.length).trim();
        resolve(result);
      } else {
        resolve("No matching content found");
      }
    } catch (error) {
      reject(error);
    }
  });
};

export const captureShow = async (text) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const data = await captureList();

      const matchedItems = data
        .map((item) => {
          const matchedIndices = item.keyword.flatMap((keyword) => {
            const index = text.indexOf(keyword);
            return index !== -1 ? [index] : [];
          });

          if (matchedIndices.length > 0) {
            return {
              ...item,
              index: matchedIndices,
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      // 找出每一项的 index 数组中的最小值，并按最小值排序
      matchedItems.sort((a, b) => {
        const minIndexA = Math.min(...a.index);
        const minIndexB = Math.min(...b.index);
        return minIndexA - minIndexB;
      });

      resolve(matchedItems);
    } catch (error) {
      reject(error);
    }
  });
};
